import React, { useState } from 'react';
import { styles } from './styles';
import { Route } from '@/services/routes/route.vm';
import { routesService } from '@/services/routes';
import useLearningRoutes from '@/context/routes/hook';
import { Content } from '@/services/contents/content.vm';
import { Stage } from '@/services/stages/stage.vm';
import Button from '@/components/input/Button';
import RouteCoverPlaceholder from './placeholder';

interface Props {
  routeId: Route['id'];
  title: Route['title'];
  description: Route['description'];
  coverImage: Route['coverImage'];
  contents?: Content[];
  stages?: Stage[];
  onStart?: () => void;
  loading: boolean;
}

const RouteCover: React.FC<Props> = ({
  routeId,
  title,
  description,
  coverImage,
  contents,
  stages,
  loading,
  onStart,
}) => {
  const { updateRoute } = useLearningRoutes();
  const [startingRoute, setStartingRoute] = useState(false);

  const startPath = () => {
    if (startingRoute) return;
    setStartingRoute(true);
    routesService
      .createRouteProgress(routeId)
      .then((progress) => {
        updateRoute(routeId, {
          progressStatus: 'IN_PROGRESS',
          userRouteProgressId: progress.id,
          progress: 0,
        });
        onStart?.();
      })
      .catch((error) => {
        console.error('Error creating route progress:', error);
      })
      .finally(() => {
        setStartingRoute(false);
      });
  };

  if (loading) return <RouteCoverPlaceholder />;

  return (
    <div style={styles.container}>
      <div style={styles.headerComponent}>
        <img src={coverImage} style={styles.imageStyle} alt={title} />
        <div style={styles.headerTextContainer}>
          <h1 style={styles.headerTitle}>{title}</h1>
          <p style={styles.headerDescription}>{description}</p>
          {(stages?.length ?? 0) > 0 && (
            <>
              <h3 style={styles.headerTitle}>Etapas</h3>
              <ul style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                {stages?.map((item, index) => (
                  <li key={item.id} style={styles.stepsItems}>
                    {item.title}
                  </li>
                ))}
              </ul>
            </>
          )}
          {(contents?.length ?? 0) > 0 && (
            <>
              <h3 style={styles.headerTitle}>Contenidos</h3>
              <ul style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                {contents?.map((item, index) => (
                  <li key={item.id} style={styles.stepsItems}>
                    {item.title}
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      </div>
      <Button
        onClick={startPath}
        variant="main"
        sx={{
          textAlign: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          margin: 16,
          position: 'sticky',
          bottom: 16,
        }}
        disabled={startingRoute}
        loading={startingRoute}
      >
        {startingRoute ? 'Cargando...' : 'Comenzar'}
      </Button>
    </div>
  );
};

export default RouteCover;
